'use client'

import { usePathname, useSearchParams } from "next/navigation"
import { useEffect, Suspense } from "react"
import posthog from 'posthog-js'

function PostHogPageViewContent() {
    const pathname = usePathname()
    const searchParams = useSearchParams()

    useEffect(() => {
        if (pathname && posthog) {
            let url = window.origin + pathname
            const searchString = searchParams?.toString()
            if (searchString) {
                url = url + "?" + searchString
            }
            posthog.capture('$pageview', {
                '$current_url': url,
            })
        }
    }, [pathname, searchParams])

    return null
}

export function PostHogPageView() {
    return (
        <Suspense fallback={null}>
            <PostHogPageViewContent />
        </Suspense>
    )
}
